unit TitleType;
{

/* Initail. */

}
interface

uses
  JS;

type
  TTitleType = class
  private
    fTitleKey: String;
    fValue: String;
    fActive: Boolean;
  public
    property TitleKey: String read fTitleKey;
    property Value: String read fValue;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TTitleType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fTitleKey := String(JSObject_Type['titleKey']);
    fValue := String(JSObject_Type['value']);
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
